import { render } from "./ClientNotificationsSetup.vue?vue&type=template&id=1cc7c946&scoped=true"
import script from "./ClientNotificationsSetup.vue?vue&type=script&lang=js"
export * from "./ClientNotificationsSetup.vue?vue&type=script&lang=js"

import "./ClientNotificationsSetup.vue?vue&type=style&index=0&id=1cc7c946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc7c946"]])

export default __exports__